import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { storage } from '@/lib/storage'

import { Card, HomeContentContainer } from '@/components'
import { useTranslations } from '@/hooks/useTranslations'

export const Route = createFileRoute('/')({
  component: IndexPage,
})

function IndexPage() {
  const t = useTranslations('select_mode')
  const navigate = useNavigate()

  useEffect(() => {
    const accessToken = storage.get('accessToken')
    const refreshToken = storage.get('refreshToken')
    if (!accessToken || !refreshToken) {
      navigate({ to: '/auth/login' })
    } else {
      navigate({ to: '/admin' })
    }
  }, [navigate])

  return (
    <HomeContentContainer>
      <div className="flex gap-4 flex-col lg:flex-row p-4 justify-center items-center">
        <Card
          id={1}
          name={t('content.mode_1.title')}
          description={t('content.mode_1.description')}
          image={''}
          path="/admin"
        />
      </div>
    </HomeContentContainer>
  )
}

